
/** Parses a duration value that may already be a number (ms) or a formatted
 *  "H:MM:SS.s" / "MM:SS.s" / "SS.s" string, into milliseconds for numeric comparison. */
export function parseDurationToMs(value: string | number | undefined | null): number {
    if (value == null) return NaN;
    if (typeof value === 'number') return value;

    const str = String(value).trim();
    if (!str) return NaN;

    const [main, frac] = str.split('.');
    const parts = main.split(':').map(p => parseInt(p, 10));
    if (parts.length === 0 || parts.some(isNaN)) return NaN;

    let seconds = 0;
    for (const p of parts) {
        seconds = seconds * 60 + p;
    }

    const fracMs = frac ? Number('0.' + frac) * 1000 : 0;
    return seconds * 1000 + fracMs;
}